import { useQuery } from '@tanstack/react-query';

import { venueGetReservationContentCountApi } from '../../api/reservations/venueGetReservationContentCountApi';
import { VenueListReservationsContentFilter } from '../../graphql/API';
import { useAppSelector } from '../../redux/hooks';

const useVenueGetReservationContentCountQuery = (
  filters: Partial<VenueListReservationsContentFilter> | undefined,
  enabled = true,
) => {
  const venueState = useAppSelector((state) => state.venue.value);

  const { data, isFetching, isLoading, refetch } = useQuery({
    queryKey: ['venueGetReservationContentCount', venueState?.id, filters],
    queryFn: () =>
      venueGetReservationContentCountApi({
        ...filters,
        venueID: venueState?.id != null ? Number(venueState.id) : undefined,
      }),
    enabled: !!venueState?.id && enabled,
    refetchOnWindowFocus: false,
  });

  return { data, isFetching, isLoading, refetch };
};

export default useVenueGetReservationContentCountQuery;
